import {
    ChangeDetectionStrategy,
    Component,
    Injector,
    Input,
    OnInit
  } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
  
@Component({
  selector: 'app-vpp-auth-form',
  templateUrl: './valid-posting-period-auth.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ValidPostingPeriodAuthFormComponent implements OnInit {
  constructor(protected injector: Injector) {}

  ngOnInit(): void {
    return;
  }

  @Input() get value() {
    return this.form.value;
  }
  set value(value: any) {
    this.form.reset(value);
  }

  get fb() {
    return this.injector.get(FormBuilder);
  }

  get msg1() {
    return this.form.controls.message1.value;
  }

  get msg2() {
    return this.form.controls.message2.value;
  }

  form = this.createForm();
  createForm() {
    const form = this.fb.group({
      id: [0, [Validators.required]],
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
      message1: ['', []],
      message2: ['', []]
    });
    return form;
  }
}
  